import {
    getItemFromLocalStorageWithExpiry
} from "@/app/[locale]/common/utils/functions/getItemFromLocalStorageWithExpiry/getItemFromLocalStorageWithExpiry";

// Check the Local Storage and call a getItemFromLocalStorageWithExpiry function

export const clearExpiredLocalStorage = () => {
    Object.keys(localStorage).forEach((key) => {
        getItemFromLocalStorageWithExpiry(key);
    });
};